// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__19jxU","clinicsSelect":"TableHeading_clinicsSelect__LLfw-"};